import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const getUserBenefitSummaries = ({ userIds, groupId }) =>
  call(websocketFetch, 'get_user_benefit_summaries', {
    user_ids: userIds,
    group_id: groupId,
    options: ['include_grace_period'],
  });
